// export action types
import { USER_LOGGED_IN } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { userLoggedIn } from 'actions/userLoggedIn';
 *
 * // dispatch action
 * store.dispatch( userLoggedIn( payload ) );
 */
export const userLoggedIn = ( payload ) => {
    return {
        type: USER_LOGGED_IN,
        payload: payload
    };
};
